<div class="layout-column custom-panel full-width full-height">
  <div class="flex layout-column padding-10 gap-10 overflow-auto">

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-name"
         (click)="onToggleSortTypeChange('name' , sortBy === 'name' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Name</span>
      <bringoz-icon *ngIf="sortBy === 'name' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'name' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-resource-id"
         (click)="onToggleSortTypeChange('resourceId' , sortBy === 'resourceId' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Resource ID</span>
      <bringoz-icon *ngIf="sortBy === 'resourceId' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'resourceId' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-duration"
         (click)="onToggleSortTypeChange('totals.totalTimeSec' , sortBy === 'totals.totalTimeSec' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Duration</span>
      <bringoz-icon *ngIf="sortBy === 'totals.totalTimeSec' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.totalTimeSec' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-distance"
         (click)="onToggleSortTypeChange('totals.totalDistanceMeter' , sortBy === 'totals.totalDistanceMeter' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Distance</span>
      <bringoz-icon *ngIf="sortBy === 'totals.totalDistanceMeter' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.totalDistanceMeter' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-stops"
         (click)="onToggleSortTypeChange('totals.totalStopsCount' , sortBy === 'totals.totalStopsCount' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Stops</span>
      <bringoz-icon *ngIf="sortBy === 'totals.totalStopsCount' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.totalStopsCount' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-packages"
         (click)="onToggleSortTypeChange('totals.totalPackagesCount' , sortBy === 'totals.totalPackagesCount' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Packages</span>
      <bringoz-icon *ngIf="sortBy === 'totals.totalPackagesCount' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.totalPackagesCount' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-weight"
         (click)="onToggleSortTypeChange('totals.totalLoad' , sortBy === 'totals.totalLoad' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Weight</span>
      <bringoz-icon *ngIf="sortBy === 'totals.totalLoad' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.totalLoad' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-volume"
         (click)="onToggleSortTypeChange('totals.totalVolume' , sortBy === 'totals.totalVolume' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Volume</span>
      <bringoz-icon *ngIf="sortBy === 'totals.totalVolume' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.totalVolume' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-spots"
         (click)="onToggleSortTypeChange('totals.totalSpots' , sortBy === 'totals.totalSpots' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Spots</span>
      <bringoz-icon *ngIf="sortBy === 'totals.totalSpots' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.totalSpots' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-income"
         (click)="onToggleSortTypeChange('totals.totalIncome' , sortBy === 'totals.totalIncome' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Income</span>
      <bringoz-icon *ngIf="sortBy === 'totals.totalIncome' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.totalIncome' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-value"
         (click)="onToggleSortTypeChange('totals.value' , sortBy === 'totals.value' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Value</span>
      <bringoz-icon *ngIf="sortBy === 'totals.value' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totals.value' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="routes-sort-synced"
         (click)="onToggleSortTypeChange('jobChangesSyncedAt' , sortBy === 'jobChangesSyncedAt' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Synced</span>
      <bringoz-icon *ngIf="sortBy === 'jobChangesSyncedAt' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'jobChangesSyncedAt' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>


  </div>
</div>
